'use client'

import { useCachedUnitProgressSWR } from '~/app/actions/progress'

export default function UnitAggregatedTime({
  courseId,
  moduleId,
  unitId,
  totalMinutes,
}: {
  courseId: string | number
  moduleId: string | number
  unitId: string | number
  totalMinutes: number
}) {
  const { data } = useCachedUnitProgressSWR({ courseId, moduleId, unitId })
  const time = data?.time || 0

  return (
    <div className="text-[10px] sm:text-sm md:text-base whitespace-nowrap text-gray-600 flex-shrink-0">
      <span className="text-uzh-lightgreen">{time}</span> / {totalMinutes} min
    </div>
  )
}
